import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/es/industrias/pharma-biotech/cumplimiento-normativo-y-soporte-a-la-calidad-fabricacion-farmaceutica")({
  head: () => buildRouteHead("/es/industrias/pharma-biotech/cumplimiento-normativo-y-soporte-a-la-calidad-fabricacion-farmaceutica"),
  component: SolutionDetail,
});

